// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* CMA */
.flexible-height {
  flex-grow: 1;
}

.pdbox {
  box-shadow: 0px 0px 5px #999;
  margin: auto;
}

@media (max-width: 1200px) {
  .pricecard {
    width: 100%;
    margin-bottom: 2rem;
  }
}
.pdbox h5 {
  color: #0fc45b;
  width: 100%;
  line-height: 3em;
  text-align: center;
  border-bottom: 1px solid #0fc45b;
}

.pdbox ul {
  margin: 1.5rem 1rem 1.5rem 0;
  list-style-type: square;
  padding-left: 40px;
}

.ugbk {
  background-color: #eeeeee;
  margin: 1em;
  padding: 1em;
  text-align: center;
}

.ugbk h6 {
  font-size: 1.2em;
  line-height: 2em;
  width: 50%;
  margin: 0 auto 0.5em auto;
  border-bottom: 1px solid #333;
  font-weight: normal;
}

.cash {
  color: #c90101;
  text-align: center;
  font-size: 2.2em;
}

.cash::before {
  content: "優惠價：";
  color: #000;
  font-size: 0.4em;
}

.cash::after {
  content: "元";
  color: #000;
  font-size: 0.4em;
}

.bt_prd {
  background-color: #0fc45b;
  display: block;
  text-align: center;
  color: #fff;
  width: 100%;
  line-height: 4em;
}

.bt_prd:hover {
  background-color: #009900;
  text-decoration: none;
  color: #fff;
}

/* ===== CMA 手機優化覆寫 (≤768px) ===== */
@media (max-width: 768px) {
  /* Banner：滿版顯示，關掉疊字 */
  .banner img {
    width: 100%;
    height: auto;
    display: block;
  }
  .cmabannertext {
    display: none !important;
  }
  /* Service Navbar：單排橫向滑動（若已在全站樣式做過可省略這段） */
  .servicenavbar {
    flex-wrap: nowrap;
    justify-content: flex-start;
    gap: 12px;
    padding: 0 12px 12px;
    top: 0; /* 避免 -top 造成擠壓 */
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    touch-action: pan-x;
  }
  .servicenavbar > a {
    flex: 0 0 auto;
  }
  .servicesq {
    width: clamp(140px, 44vw, 200px);
    height: clamp(140px, 44vw, 200px);
    font-size: clamp(18px, 6vw, 28px);
    border-radius: 16px;
    scroll-snap-align: start;
  }
  .secsub {
    font-size: clamp(12px, 3.5vw, 16px);
  }
  /* 次導覽：改為可橫向滑動的 pills */
  .cpasubnav {
    display: flex !important;
    gap: 12px;
    padding: 16px 12px 24px;
    margin-bottom: 24px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .cpasubnav a div {
    white-space: nowrap;
  }
  /* 版面寬度：把本頁大量的 w-75 改成滿版 */
  .container img.w-75 {
    width: 100% !important;
    height: auto !important;
  }
  .container .w-75 {
    width: 100% !important;
  } /* 文字區塊也鋪滿 */
  /* YouTube iframe：自適應 16:9 */
  iframe {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 16/9;
  }
  /* Why/各段落間距收斂 */
  .beckertitlename {
    margin: 40px 0 24px !important;
  }
  /* 價格卡：直向堆疊、卡片滿寬 */
  .row > .pricecard {
    width: 100% !important;
    margin-bottom: 24px;
  }
  .pricecard .card {
    width: 100% !important;
  }
  .pdbox ul {
    padding-left: 20px;
    margin: 1rem 0;
  }
  .ugbk {
    margin: 0.75rem;
    padding: 0.75rem;
  }
  .ugbk h6 {
    width: 100%;
    font-size: 1rem;
  }
  .cash {
    font-size: 1.75em;
  }
  .bt_prd {
    line-height: 3.2em;
  }
  /* 大表格：橫向捲動避免爆版 */
  .table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cma/styles/cma.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,QAAA;AACA;EACC,YAAA;AAED;;AAAA;EACI,4BAAA;EACH,YAAA;AAGD;;AADA;EACC;IACC,WAAA;IACA,mBAAA;EAIA;AACF;AAFA;EACC,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AAID;;AAFA;EACC,4BAAA;EACA,uBAAA;EACG,kBAAA;AAKJ;;AAHA;EACI,yBAAA;EACH,WAAA;EACA,YAAA;EACA,kBAAA;AAMD;;AAJA;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AAOJ;;AALA;EACI,cAAA;EACH,kBAAA;EACA,gBAAA;AAQD;;AANA;EACI,eAAA;EACA,WAAA;EACH,gBAAA;AASD;;AAPA;EACI,YAAA;EACA,WAAA;EACH,gBAAA;AAUD;;AARA;EACI,yBAAA;EACH,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAWD;;AATA;EACC,yBAAA;EACA,qBAAA;EACA,WAAA;AAYD;;AATA,oCAAA;AACA;EACC,qBAAA;EACA;IAAc,WAAA;IAAa,YAAA;IAAc,cAAA;EAexC;EAdD;IAAiB,wBAAA;EAiBhB;EAfD,0CAAA;EACA;IACE,iBAAA;IACA,2BAAA;IACA,SAAA;IACA,oBAAA;IACA,MAAA,EAAA,iBAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;IACA,6BAAA;IACA,mBAAA;EAiBD;EAfD;IAAqB,cAAA;EAkBpB;EAjBD;IACE,gCAAA;IACA,iCAAA;IACA,iCAAA;IACA,mBAAA;IACA,wBAAA;EAmBD;EAjBD;IAAS,mCAAA;EAoBR;EAlBD,uBAAA;EACA;IACE,wBAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,iCAAA;EAoBD;EAlBD;IAAkB,mBAAA;EAqBjB;EAnBD,0BAAA;EACA;IAAsB,sBAAA;IAAwB,uBAAA;EAuB7C;EAtBD;IAAmB,sBAAA;EAyBlB,EAzB4C,YAAA;EAE7C,4BAAA;EACA;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;EAyBD;EAtBD,gBAAA;EACA;IAAkB,8BAAA;EAyBjB;EAvBD,kBAAA;EACA;IAAmB,sBAAA;IAAwB,mBAAA;EA2B1C;EA1BD;IAAkB,sBAAA;EA6BjB;EA5BD;IAAW,kBAAA;IAAoB,cAAA;EAgC9B;EA/BD;IAAO,eAAA;IAAgB,gBAAA;EAmCtB;EAlCD;IAAU,WAAA;IAAa,eAAA;EAsCtB;EArCD;IAAO,iBAAA;EAwCN;EAvCD;IAAS,kBAAA;EA0CR;EAxCD,iBAAA;EACA;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EA0CD;AACF","sourcesContent":["/* CMA */\n.flexible-height{\n\tflex-grow: 1;\n}\n.pdbox {\n    box-shadow:0px 0px 5px #999;\n\tmargin: auto;\n}\n@media (max-width:1200px) {\n\t.pricecard{\n\t\twidth: 100%;\n\t\tmargin-bottom: 2rem;\n\t}\n}\n.pdbox h5 {\n\tcolor: #0fc45b;\n\twidth: 100%;\n\tline-height: 3em;\n\ttext-align: center;\n\tborder-bottom: 1px solid #0fc45b;\n}\n.pdbox ul {\n\tmargin: 1.5rem 1rem 1.5rem 0;\n\tlist-style-type: square;\n    padding-left: 40px;\n}\n.ugbk {\n    background-color: #eeeeee;\n\tmargin: 1em;\n\tpadding: 1em;\n\ttext-align: center;\n}\n.ugbk h6 {\n    font-size: 1.2em;\n    line-height: 2em;\n    width: 50%;\n    margin: 0 auto 0.5em auto;\n    border-bottom: 1px solid #333;\n    font-weight: normal;\n}\n.cash {\n    color: #c90101;\n\ttext-align: center;\n\tfont-size: 2.2em;\n}\n.cash::before{\n    content:\"優惠價：\";\n    color:#000;\n\tfont-size: .4em;\n}\n.cash::after{\n    content:\"元\";\n    color:#000;\n\tfont-size: .4em;\n}\n.bt_prd {\n    background-color: #0fc45b;\n\tdisplay: block;\n\ttext-align: center;\n\tcolor: #fff;\n\twidth: 100%;\n\tline-height: 4em;\n}\n.bt_prd:hover {\n\tbackground-color: #009900;\n\ttext-decoration: none;\n\tcolor: #fff;\n}\n\n/* ===== CMA 手機優化覆寫 (≤768px) ===== */\n@media (max-width: 768px) {\n\t/* Banner：滿版顯示，關掉疊字 */\n\t.banner img { width: 100%; height: auto; display: block; }\n\t.cmabannertext { display: none !important; }\n  \n\t/* Service Navbar：單排橫向滑動（若已在全站樣式做過可省略這段） */\n\t.servicenavbar{\n\t  flex-wrap: nowrap;\n\t  justify-content: flex-start;\n\t  gap: 12px;\n\t  padding: 0 12px 12px;\n\t  top: 0;                        /* 避免 -top 造成擠壓 */\n\t  overflow-x: auto;\n\t  overflow-y: hidden;\n\t  -webkit-overflow-scrolling: touch;\n\t  scroll-snap-type: x mandatory;\n\t  touch-action: pan-x;\n\t}\n\t.servicenavbar > a { flex: 0 0 auto; }\n\t.servicesq{\n\t  width: clamp(140px, 44vw, 200px);\n\t  height: clamp(140px, 44vw, 200px);\n\t  font-size: clamp(18px, 6vw, 28px);\n\t  border-radius: 16px;\n\t  scroll-snap-align: start;\n\t}\n\t.secsub{ font-size: clamp(12px, 3.5vw, 16px); }\n  \n\t/* 次導覽：改為可橫向滑動的 pills */\n\t.cpasubnav{\n\t  display: flex !important;\n\t  gap: 12px;\n\t  padding: 16px 12px 24px;\n\t  margin-bottom: 24px;\n\t  overflow-x: auto;\n\t  -webkit-overflow-scrolling: touch;\n\t}\n\t.cpasubnav a div{ white-space: nowrap; }\n  \n\t/* 版面寬度：把本頁大量的 w-75 改成滿版 */\n\t.container img.w-75 { width: 100% !important; height: auto !important; }\n\t.container .w-75 { width: 100% !important; } /* 文字區塊也鋪滿 */\n  \n\t/* YouTube iframe：自適應 16:9 */\n\tiframe {\n\t  width: 100% !important;\n\t  height: auto !important;\n\t  aspect-ratio: 16 / 9;\n\t}\n  \n\t/* Why/各段落間距收斂 */\n\t.beckertitlename{ margin: 40px 0 24px !important; }\n  \n\t/* 價格卡：直向堆疊、卡片滿寬 */\n\t.row > .pricecard{ width: 100% !important; margin-bottom: 24px; }\n\t.pricecard .card{ width: 100% !important; }\n\t.pdbox ul{ padding-left: 20px; margin: 1rem 0; }\n\t.ugbk{ margin: .75rem; padding: .75rem; }\n\t.ugbk h6{ width: 100%; font-size: 1rem; }\n\t.cash{ font-size: 1.75em; }\n\t.bt_prd{ line-height: 3.2em; }\n  \n\t/* 大表格：橫向捲動避免爆版 */\n\t.table{\n\t  display: block;\n\t  overflow-x: auto;\n\t  white-space: nowrap;\n\t}\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
